<template>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="600">
		<v-btn slot="activator" icon>
			<v-icon>unarchive</v-icon>
		</v-btn>
		<v-card class="px-4 py-4">
			<v-card-title class="headline">Upload Drawing</v-card-title>

			<v-card-text>
				<v-layout column>

					<v-flex xs8>
						<v-text-field
							label="Select File"
							@click="pickFile"
							v-model="imageName"
							prepend-icon="attach_file"
						></v-text-field>

						<input
							type="file"
							style="display: none"
							ref="image"
							accept="image/*"
							@change="onFilePicked"
						/>
					</v-flex>

				</v-layout>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="green darken-1" flat="flat" @click="resetForm">
					Cancel
				</v-btn>

				<v-btn color="green darken-1" flat="flat" @click="fileUpload">
					Upload
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Vuex from "vuex";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	name: "FileUpload",

	data() {
		return {
			dialog: false,
			imageName: "",
			imageUrl: "",
			imageFile: "",
			pano: false
		};
	},

	computed: {
		...mapState({	//showTestDialog: state => state.ui.showTestDialog,
		}),

	},

	methods: {
		...mapMutations([ "",
		]),
		...mapActions(["uploadDrawing", ]),

		pickFile: function() {
			this.$refs.image.click();
		},

		onFilePicked(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				this.imageName = files[0].name;
				if (this.imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.imageUrl = fr.result;
					this.imageFile = files[0]; // this is an image file that can be sent to server...
				});
			} else {
				this.resetForm();
			}
		},

		resetForm: function() {
			this.imageName = null;
			this.imageFile = null;
			this.imageUrl = null;
			this.dialog = false;
		},

		fileUpload: function() {
			if (!this.imageFile) {
				console.log("No File Selected");
				return;
			}

			var imageData;

			const vm = this;

			const toDataURL = url =>
				fetch(url)
					.then(response => response.blob())
					.then(
						blob =>
							new Promise((resolve, reject) => {
								const reader = new FileReader();
								reader.onloadend = () => resolve(reader.result);
								reader.onerror = reject;
								reader.readAsDataURL(blob);
							})
					);

			toDataURL(this.imageUrl)
				.then(dataUrl => {
					//console.log('RESULT:', dataUrl)
					imageData = dataUrl;

					this.uploadDrawing({
						file: imageData
					});
				})
				.then(() => {
					this.resetForm();
					this.setShowIndicatorPhotoReview(1);
					// the backend is not able to tell me when it is really done :(
					setTimeout(() => {
						vm.fetchFullRoom({
							bldgAlpha: this.selectedRoom.bldgAlpha,
							number: this.selectedRoom.number
						});
					}, 2000);
				});
		}
	}
};
</script>

<style>
.cardtext > .v-list__tile {
	height: 40px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/forms/DrawingUpload.vue